export default "__VITE_ASSET__Bmst0M0P__"